import React from 'react';
import ConversationIcon from '../../../images/icons/iconConversation.svg';
import './DialogIndicator.scss';

export default function DialogIndicator({tooltip}) {
  return (
    <div className="dialogIndicator">
      <img src={ConversationIcon} className='indicatorImage' alt="Conversation Icon" />
      <div className="tooltip">
        <div className="tooltip-content">
          <img src={ConversationIcon} alt="tooltipConversationIcon" className='tooltipConversationIcon' />
          <span>{tooltip}</span>
        </div>
      </div>
    </div>
  );
}
